import { useEffect } from "react";
import CoreValue from "./CoreValue";
import Future from "./Future";
import UniqueValue from "./UniqueValue";
import Aos from "aos";
import Books from "./Books";
import Footer from "../Index/Footer";

export default function Content() {
  useEffect(() => {
    Aos.init({ duration: 1000, once: true });
  }, []);

  return (
    <>
      <Future />
      <UniqueValue />
      <CoreValue />
      <Books />
      <Footer />
    </>
  );
}
